import PeopleAdmissions from './PeopleAdmissions';

export { type PeopleAdmissionsProps } from './PeopleAdmissions';
export default PeopleAdmissions;
